import React, { useState } from "react";
import { useReduxStore } from "../../hooks/useReduxStore";
const useCheckout = () => {
  // const [modalType, setModalType] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const { dispatch, getState } = useReduxStore();
  const { userData } = getState("AUTH");
  const { itemDetail:subscription } = getState("Item");
  const itemDetail={ ...subscription,category:[]}
  const subTotal = itemDetail?.price || 0;
  const discountPrice = 0;
  const serviceCharges = Number(itemDetail?.tax|| 0);
  const total = subTotal - discountPrice + serviceCharges;
  // const handelModalType = (type,message) =>{
  //    setModalType(type)
  //    setErrorMessage(message)
  //    ;}
// console.log("subscription----",subscription)
  return {
    itemDetail,
    subTotal,
    discountPrice,
    serviceCharges,
    total,
    // modalType,
    // errorMessage,
    // handelModalType,
    userData,
  };
};

export default useCheckout;
